import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["validationErrors"])
  },
  watch: {
    validationErrors: function(errors) {
      Object.keys(errors).forEach(key => {
        this.$validator.errors.add({
          field: key,
          msg: errors[key]
        });
      });
    }
  }
};
